import React from 'react';
import { PageSection } from '../PageSection';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { PriceBlock } from '../PriceBlock';
import { PRODUCT_NAME, finalStages } from '../../data/salesContent';
export function FinalCtaSection() {
  return <PageSection labelledBy="final-offer-title" className="bg-carbon-900" data-id="element-95" data-mp="2ditugignm3pj">
      <div className="rounded-2xl border-2 border-accent-500 bg-carbon-950 p-6 text-center md:p-10" data-id="element-96" data-mp="2dlpp9xx7gc9r">
        <ProductImage className="mx-auto w-full max-w-lg" data-id="element-97" data-mp="2mk1fvzy2na27" />
        <h2 id="final-offer-title" className="mt-6 text-3xl font-extrabold uppercase leading-[1.05] text-white md:text-[2.5rem]" data-id="element-98" data-mp="2mji83c24y21w">
          {PRODUCT_NAME}
        </h2>
        <p className="mt-2 text-base font-semibold uppercase text-carbon-300" data-id="element-99" data-mp="2w9kyr5lsb3x2">El sistema completo para enseñar Construcciones</p>
        <p className="mx-auto mt-4 max-w-lg font-display text-sm font-bold uppercase leading-relaxed tracking-wide text-accent-400 md:text-base" data-id="element-100" data-mp="3aa5ic3zix3rm">
          {finalStages.join(' • ')}
        </p>
        <p className="mt-5 font-display text-2xl font-extrabold uppercase tracking-wide text-white md:text-3xl" data-id="element-101" data-mp="221w39nf7wcbf">10 volúmenes + 5 bonos</p>
        <PriceBlock className="mt-5" data-id="element-102" data-mp="263zhukx6nx0x" />
        <div className="mt-7" data-id="element-103" data-mp="2b0zniuq4exri">
          <CtaButton note="Pago único · Acceso inmediato · Entrega digital" data-id="element-104" data-mp="2azocqay9cpqw">Quiero acceder al sistema completo</CtaButton>
        </div>
      </div>
    </PageSection>;
}